<div class="dashboard-container">
  <!-- Filtros de Pesquisa -->
  <div class="filters-section">
    <mat-card class="filters-card">
      <mat-card-title class="filters-header">
        <div class="title-section">
          <mat-icon class="filter-icon">filter_list</mat-icon>
          <span>
            Filtros de Pesquisa
            @if (!filtersExpanded && activeFilterCount > 0) {
              <span class="filter-count-badge">{{activeFilterCount}}</span>
            }
          </span>
          @if (hasActiveFilters()) {
            <span class="filter-indicator" style="color: white !important;">
              <mat-icon>fiber_manual_record</mat-icon>
              Ativos
            </span>
          }
        </div>
        <button mat-icon-button (click)="toggleFilters()" class="toggle-filters">
          <mat-icon>{{filtersExpanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
      </mat-card-title>

      @if (filtersExpanded) {
        <mat-card-content class="filters-content">
          <div class="filters-grid">
            <!-- Data Início -->
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>
                <mat-icon>calendar_today</mat-icon>
                Data Início
              </mat-label>
              <input matInput [matDatepicker]="dataInicioPicker" [formControl]="dataInicio" placeholder="DD/MM/AAAA">
              <mat-datepicker-toggle matSuffix [for]="dataInicioPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataInicioPicker></mat-datepicker>
              <mat-hint>Data inicial do período</mat-hint>
            </mat-form-field>

            <!-- Data Fim -->
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>
                <mat-icon>event</mat-icon>
                Data Fim
              </mat-label>
              <input matInput [matDatepicker]="dataFimPicker" [formControl]="dataFim" placeholder="DD/MM/AAAA">
              <mat-datepicker-toggle matSuffix [for]="dataFimPicker"></mat-datepicker-toggle>
              <mat-datepicker #dataFimPicker></mat-datepicker>
              <mat-hint>Data final do período</mat-hint>
            </mat-form-field>

            <!-- Status -->
            <app-searchable-select
              class="filter-field"
              [options]="statusOptions"
              [selected]="selectedStatuses.value || []"
              (selectedChange)="selectedStatuses.setValue($event)"
              label="Status"
              icon="check_circle"
              hint="Digite ou selecione status"
              [multiple]="true">
            </app-searchable-select>

            <!-- UF -->
            <app-searchable-select
              class="filter-field"
              [options]="ufOptions"
              [selected]="selectedUfs.value || []"
              (selectedChange)="selectedUfs.setValue($event)"
              label="UF"
              icon="location_on"
              hint="Digite ou selecione UFs"
              [multiple]="true">
            </app-searchable-select>

            <!-- KIT -->
            <app-searchable-select
              class="filter-field"
              [options]="kitOptions"
              [selected]="selectedKits.value || []"
              (selectedChange)="selectedKits.setValue($event)"
              label="KIT"
              icon="category"
              hint="Digite ou selecione KITs"
              [multiple]="true">
            </app-searchable-select>
          </div>

          <div class="filter-actions">
            <button mat-raised-button color="primary" (click)="applyFilters()" class="search-btn">
              <mat-icon>search</mat-icon>
              Pesquisar
            </button>
            <button mat-stroked-button (click)="clearFilters()" class="clear-btn">
              <mat-icon>refresh</mat-icon>
              Limpar Filtros
            </button>
          </div>
        </mat-card-content>
      }
    </mat-card>
  </div>

  <!-- Chips de filtros ativos -->
  @if (hasActiveFilters()) {
    <div class="active-filters-chips">
      @if (dataInicio.value || dataFim.value) {
        <span class="filter-chip">
          <mat-icon>calendar_today</mat-icon>
          {{periodLabel}}
          <button class="chip-remove" (click)="clearDateFilter()" title="Remover filtro de período">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
      @for (status of (selectedStatuses.value || []); track status) {
        <span class="filter-chip">
          <mat-icon>check_circle</mat-icon>
          {{getStatusLabel(status)}}
          <button class="chip-remove" (click)="removeStatusFilter(status)" title="Remover filtro de status">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
      @for (uf of (selectedUfs.value || []); track uf) {
        <span class="filter-chip">
          <mat-icon>location_on</mat-icon>
          {{uf}}
          <button class="chip-remove" (click)="removeUfFilter(uf)" title="Remover filtro de UF">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
      @for (kit of (selectedKits.value || []); track kit) {
        <span class="filter-chip">
          <mat-icon>category</mat-icon>
          {{getKitLabel(kit)}}
          <button class="chip-remove" (click)="removeKitFilter(kit)" title="Remover filtro de kit">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      }
    </div>
  }

  <!-- Loading Principal -->
  @if (isLoading) {
    <div class="dashboard-loading">
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <p class="loading-text">Carregando dados...</p>
    </div>
  } @else {
    <!-- Cards de Resumo -->
    <div class="summary-cards">
    <mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>local_shipping</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_medicos_ativos }}</div>
          <div class="card-label">Médicos Ativos</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>assignment_turned_in</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_medicos_inativos }}</div>
          <div class="card-label">Médicos Inativos</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card bg-analise">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_pedidos_analise }}</div>
          <div class="card-label">Total de Pedidos em Análise</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card bg-aprovado">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_pedidos_aprovados }}</div>
          <div class="card-label">Total de Pedidos Aprovados</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card bg-cancelado">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_pedidos_cancelados }}</div>
          <div class="card-label">Total de Pedidos Cancelados</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card bg-entregue">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_pedidos_entregues }}</div>
          <div class="card-label">Total de Pedidos Entregues</div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="summary-card bg-default">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>cancel</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.pedidos_total }}</div>
          <div class="card-label">Total de Pedidos</div>
        </div>
      </mat-card-content>
    </mat-card>

    <!--<mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>medical_services</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{ dashboardFiltered?.total_medicos_ativos }}</div>
          <div class="card-label">Médicos Ativos</div>
          @if (dashboardFiltered?.total_medicos_inativos > 0) {
            <div class="card-label-secondary">{{ dashboardFiltered?.total_medicos_inativos }} inativos</div>
          }
        </div>
      </mat-card-content>
    </mat-card>-->

    <!--<mat-card class="summary-card">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>percent</mat-icon>
        </div>
        <div class="card-content">
          <div class="card-value">{{getCompletionRate()}}%</div>
          <div class="card-label">Taxa de Conclusão</div>
          <div class="card-label-secondary">entregas ÷ total de resgates</div>
        </div>
      </mat-card-content>
    </mat-card>-->
  </div>

  <!-- ── Visão Geral ─────────────────────────────────────────────── -->
  <div class="section-header" [class.section-header--highlighted]="hasActiveFilters() && !selectedKits.value?.length">
    <mat-icon class="section-icon">bar_chart</mat-icon>
    <span>Visão Geral</span>
  </div>
  <div class="charts-container" [class.charts-loading]="isLoading">
    <!-- Mensal: usa entregas_realizadas, cancelamentos, assinaturas_vigentes da API -->
    <mat-card class="chart-card chart-card--wide">
      <mat-card-title>Entregas, Cancelamentos e Assinaturas por Mês</mat-card-title>
      @if (periodLabel) { <mat-card-subtitle>{{periodLabel}}</mat-card-subtitle> }
      <mat-card-content>
        @if (!hasMonthlyData) { <div class="no-data-msg"><mat-icon>hourglass_empty</mat-icon> Aguardando dados da API</div> }
        <canvas id="verticalBarChart"></canvas>
      </mat-card-content>
    </mat-card>

    <!-- Status: aguardando GET /resgate/status -->
    <mat-card class="chart-card">
      <mat-card-title>Status dos Pedidos</mat-card-title>
      <mat-card-subtitle>Distribuição por situação atual dos resgates@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasStatusData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá entregues, em trânsito, pendentes e cancelados</span>
            </div>
          </div>
        }
        <canvas id="pieChart"></canvas>
      </mat-card-content>
    </mat-card>

    <!-- UF: aguardando GET /dashboard/por-uf -->
    <mat-card class="chart-card" [class.chart-card--highlighted]="selectedUfs.value?.length > 0">
      <mat-card-title>Ranking de Pedidos por UF</mat-card-title>
      <mat-card-subtitle>Top 10 estados com maior volume de resgates@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasUfData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá ranking das {{ufOptions.length}} UFs do programa</span>
            </div>
          </div>
        }
        <canvas id="horizontalBarChart"></canvas>
      </mat-card-content>
    </mat-card>

    <!-- rankingTop10Especialidades -->
    <mat-card class="chart-card" [class.chart-card--highlighted]="selectedUfs.value?.length > 0">
      <mat-card-title>Ranking de Especialidades</mat-card-title>
      <mat-card-subtitle>Top 10 por especialidade @if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasUfData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá ranking especialidades do programa</span>
            </div>
          </div>
        }
        <canvas id="rankingEspecialidadesChart"></canvas>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- ── Visão por Kit ───────────────────────────────────────────── -->
  <div id="section-kit" class="section-header" [class.section-header--highlighted]="selectedKits.value?.length > 0">
    <mat-icon class="section-icon">medication</mat-icon>
    <span>Visão por Kit</span>
  </div>
  <div class="charts-container" [class.charts-loading]="isLoading">
    <strong class="comming-soon">Em construção...</strong>
    <!--<mat-card class="chart-card">
      <mat-card-title>Distribuição por Tipo de Kit</mat-card-title>
      <mat-card-subtitle>Clenil A vs. Clenil A + Aquoso — proporção de solicitações@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasKitData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá comparativo entre Kit 1 (Clenil A) e Kit 2 (Clenil A + Aquoso)</span>
            </div>
          </div>
        }
        <canvas id="kitDonutChart"></canvas>
      </mat-card-content>
    </mat-card>-->

    <!--<mat-card class="chart-card">
      <mat-card-title>Entregas por Kit ao Longo do Ano</mat-card-title>
      <mat-card-subtitle>Evolução mensal comparativa entre os 2 kits do programa@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasKitData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá evolução mensal por kit</span>
            </div>
          </div>
        }
        <canvas id="kitBarChart"></canvas>
      </mat-card-content>
    </mat-card>-->
  </div>

  <!-- ── Visão por Região ────────────────────────────────────────── -->
  <div id="section-uf" class="section-header" [class.section-header--highlighted]="selectedUfs.value?.length > 0">
    <mat-icon class="section-icon">map</mat-icon>
    <span>Visão por Região</span>
  </div>
  <div class="charts-container">
    <strong class="comming-soon">Em construção...</strong>
    <!--<mat-card class="chart-card">
      <mat-card-title>Entregas por Macrorregião</mat-card-title>
      <mat-card-subtitle>Recorte geográfico das solicitações do programa@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasRegionData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá volume por macrorregião (N, NE, CO, SE, S)</span>
            </div>
          </div>
        }
        <canvas id="regionChart"></canvas>
      </mat-card-content>
    </mat-card>-->

    <!--<mat-card class="chart-card region-detail-card">
      <mat-card-title>Detalhamento por Região</mat-card-title>
      <mat-card-subtitle>Participação relativa de cada macrorregião</mat-card-subtitle>
      <mat-card-content>
        @if (regionData.length === 0) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá participação % por região com UFs correspondentes</span>
            </div>
          </div>
        } @else {
          <div class="region-list">
            @for (region of regionData; track region.name) {
              <div class="region-item">
                <div class="region-info">
                  <span class="region-dot" [style.background]="region.color"></span>
                  <span class="region-name">{{ region.name }}</span>
                  <span class="region-ufs">{{ region.ufs }}</span>
                </div>
                <div class="region-stats">
                  <span class="region-value">{{ formatNumber(region.value) }}</span>
                  <div class="region-bar-wrap">
                    <div class="region-bar" [style.width.%]="region.pct" [style.background]="region.color"></div>
                  </div>
                  <span class="region-pct">{{ region.pct }}%</span>
                </div>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>-->
  </div>

  <!-- ── Visão por Especialidade Médica ─────────────────────────── -->
  <div class="section-header">
    <mat-icon class="section-icon">local_hospital</mat-icon>
    <span>Visão por Especialidade Médica</span>
  </div>
  <div class="charts-container">
    <strong class="comming-soon">Em construção...</strong>
    <!--<mat-card class="chart-card chart-card--wide">
      <mat-card-title>Especialidades com maior adesão ao programa (Top 8)</mat-card-title>
      <mat-card-subtitle>Segmentação por área de atuação do médico prescritor@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasSpecialtyData) {
          <div class="no-data-msg no-data-msg--pending">
            <mat-icon>schedule</mat-icon>
            <div class="no-data-msg__text">
              <strong>Endpoint em integração</strong>
              <span>Exibirá ranking das especialidades com maior volume de resgates</span>
            </div>
          </div>
        }
        <canvas id="specialtyChart"></canvas>
      </mat-card-content>
    </mat-card>-->
  </div>

  <!-- ── Visão Cumulativa ────────────────────────────────────────── -->
  <div id="section-cumulative" class="section-header" [class.section-header--highlighted]="(dataInicio.value || dataFim.value) && !selectedKits.value?.length && !selectedUfs.value?.length">
    <mat-icon class="section-icon">trending_up</mat-icon>
    <span>Visão Cumulativa</span>
  </div>
  <div class="charts-container">
    <!-- Card 1: Médicos -->
    <mat-card class="chart-card">
      <div class="card-header">
        <div>
          <mat-card-title>Evolução de Médicos</mat-card-title>
          <mat-card-subtitle>Ativos e Inativos ao longo do tempo</mat-card-subtitle>  
        </div>
        <div class="padding-right">
          <span class="filter-indicator " style="color: white !important;">
              Total {{ totalMedicosAcumulado }}
          </span>
        </div>
        
      </div>
      <mat-card-content>
        @if (!hasCumulativeDataDoctors) { <div class="no-data-msg"><mat-icon>hourglass_empty</mat-icon> Aguardando dados da API</div> }
        <canvas id="cumulativeDoctorsChart"></canvas>
      </mat-card-content>
    </mat-card>

    <!-- Card 2: Pedidos -->
    <mat-card class="chart-card">
      <div class="card-header">
        <div>
          <mat-card-title>Evolução de Pedidos</mat-card-title>
        <mat-card-subtitle>Total, Entregues, Análise, Enviados e Cancelados</mat-card-subtitle>
        </div>
        <div class="padding-right">
          <span class="filter-indicator " style="color: white !important;">
              Total {{ totalPedidosAcumulado }}
          </span>
        </div>
      </div>
      <mat-card-content>
        @if (!hasCumulativeDataOrders) { <div class="no-data-msg"><mat-icon>hourglass_empty</mat-icon> Aguardando dados da API</div> }
        <canvas id="cumulativeOrdersChart"></canvas>
      </mat-card-content>
    </mat-card>

    <!-- Derivado de entregas_realizadas / (entregas + cancelamentos) por mês -->
    <!--<mat-card class="chart-card">
      <mat-card-title>% de Entregas Concluídas por Mês</mat-card-title>
      <mat-card-subtitle>entregas ÷ (entregas + cancelamentos)@if (periodLabel) { · {{periodLabel}} }</mat-card-subtitle>
      <mat-card-content>
        @if (!hasMonthlyData) { <div class="no-data-msg"><mat-icon>hourglass_empty</mat-icon> Aguardando dados da API</div> }
        <canvas id="percentageChart"></canvas>
      </mat-card-content>
    </mat-card>-->
  </div>

  <!-- Gráficos Antigos (mantidos para compatibilidade) -->
  <div class="grid-container" style="display: none;">
    <div class="chart-container">
      <canvas id="usersChart"></canvas>
      <canvas id="barChart"></canvas>
    </div>
  </div>
  }
</div>
